import { Flex, GridItem, Typography } from '@nilohealth/core-ui'
import { useCurrentProfessional } from '@professionals/professionals.hooks'
import { displayGreeting } from '@utils/time'

import DashboardTitle from '@dashboard/dashboard-title'
import DashboardLayout from '@dashboard/dashboard.layout'
import DashboardBigNumberGroup from '@dashboard/dashboard-bignumber-group'

import { DashboardGroupCard } from '@dashboard/dashboard.styles'
import { useDashboardByType } from '@dashboard/dashboard.hooks'

import HomeSkeleton from './home.skeleton'

const Home = () => {
  const professional = useCurrentProfessional()

  const firstName = professional?.name?.split(' ')?.[0] ?? 'usuário'

  const { dashboards, isLoading } = useDashboardByType({ type: 'home' })

  const homeDashboard = dashboards?.[0]

  if (isLoading || !homeDashboard) {
    return (
      <DashboardLayout>
        <HomeSkeleton />
      </DashboardLayout>
    )
  }
  return (
    <DashboardLayout>
      <DashboardTitle>
        <Flex direction="column" gap="quarck">
          <Typography type="headingLarge" weight="bold" color="neutralLowDark">
            {displayGreeting()}, {firstName} 👋
          </Typography>

          <Typography type="subtitleXXSmall" weight="medium" color="neutralLowMedium">
            Confira os principais indicadores
          </Typography>
        </Flex>
      </DashboardTitle>

      <GridItem column=" -1 / 1" css={{ marginTop: '$xxsmall', width: '100%' }}>
        <Flex direction="column" gap="small" css={{ width: '100%' }}>
          {homeDashboard.groups.map(group => (
            <DashboardGroupCard key={group.id}>
              <DashboardBigNumberGroup group={group} mode="home" />
            </DashboardGroupCard>
          ))}
        </Flex>
      </GridItem>
    </DashboardLayout>
  )
}

export default Home
